export const MAX_SAFE_GQL_INTEGER = 2_147_483_647
export const MAX_SAFE_GQL_FLOAT = Number.MAX_SAFE_INTEGER
export const DEFAULT_REFETCH_INTERVAL: number = 5_000 // [ms]
